import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {ResponsiveBar} from '@nivo/bar';

export default function BarChart(props) {
  const {data, chartContainerHeight, className, ...rest} = props;

  function height() {
    const containerHeight = {height: chartContainerHeight};
    return containerHeight;
  }

  return (
    <div style={height()}>
      <ResponsiveBar className={classnames(className)} data={data} {...rest} />
    </div>
  );
}

BarChart.defaultProps = {};

BarChart.propTypes = {
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** Represents chart data. */
  data: PropTypes.array.isRequired,
  /** Represents the height of container for chart. */
  chartContainerHeight: PropTypes.string.isRequired,
};
